import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from './config.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { lastValueFrom, map } from 'rxjs';
@Injectable({
  providedIn: 'root'
})

export class GoogleAuthService {
  baseUrl!: String;
  private parseHeaders = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private sanitizer: DomSanitizer,
  ) {
    this.baseUrl = this.configService.getBaseUrl()
  }

  public getSellerDetails() {
    return JSON.parse(localStorage.getItem('admin_Details') ?? "null");
  }

  public getGoogleProfile(): any {
    let url = this.baseUrl + "/GoogleDrive/GetGoogleProfile";
    return this.http.get(url, this.parseHeaders);
  }

  public getGoogleAuthHistory(): any {
    let url = this.baseUrl + "/GoogleDrive/GetGoogleAuthHistory";
    return this.http.post(url, this.parseHeaders);
  }

  public removeGoogleAccount(): any {
    const userId = this.getSellerDetails()?.UserID;
    let url = this.baseUrl + "/GoogleDrive/RemoveGoogleAccount?userID=" + userId;
    return this.http.post(url, this.parseHeaders);
  }

  public sendCodeToBackend(code: string, redirection: string) {
    let sendingData = {
      code: code,
      redirectUri: redirection
    }
    let url = this.baseUrl + "/GoogleDrive/LinkAccount";
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public uploadFileToDrive(file: File, folderName: string): Promise<string> {
    if (!file) {
      throw new Error('File must be provided for upload.');
    }
    if (!folderName) {
      throw new Error('folderName must be provided.');
    }
    const formData = new FormData();
    formData.append('file', file, file.name);
    formData.append('folderName', folderName);
    const url = this.baseUrl + "/GoogleDrive/UploadFile";
    return lastValueFrom(
      this.http.post<any>(url, formData).pipe(
        map(res => {
          if (res?.Result === 'Success') {
            return res.ResponseData;
          } else {
            throw new Error(res.responseData || 'Upload failed');
          }
        })
      )
    );
  }

  public async getSecureFileUrl(fileId: string): Promise<SafeResourceUrl> {
    if (!fileId) {
      return this.sanitizer.bypassSecurityTrustResourceUrl('assets/image-error.png');
    }
    try {
      const objectUrl = await this.fetchPrivateFileStream(fileId);
      return this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);
    } catch (error) {
      console.error(`Failed to bind secure file ${fileId}:`, error);
      return this.sanitizer.bypassSecurityTrustResourceUrl('assets/img/placeholder.png');
    }
  }

  public fetchPrivateFileStream(fileId: string): Promise<string> {
    let sendingData = { fileID: fileId };
    const url = this.baseUrl + "/GoogleDrive/FetchFile";
    return lastValueFrom(
      this.http.post(url, sendingData, {
        ...this.parseHeaders,
        responseType: 'blob'
      }).pipe(
        map((blob: Blob) => {
          return URL.createObjectURL(blob);
        })
      )
    );
  }

  public async deleteDriveFile(fileId: string): Promise<any> {
    if (!fileId) return;
    const sendingData = {
      fileID: fileId
    };
    const url = this.baseUrl + "/GoogleDrive/DeleteFile";
    try {
      const res: any = await lastValueFrom(this.http.post(url, sendingData, this.parseHeaders));
      if (res?.Result === 'Success') {
        return res;
      } else {
        throw new Error(res?.ResponseData || 'Failed to delete file from Drive');
      }
    } catch (error) {
      console.error('Delete error:', error);
      throw error;
    }
  }

}